import { getLocalStorage } from "global/utils/safeJsonParse";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import SalirIcon from "_+_Portal/assets/images/generico/SalirIcon";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import EstudioIcon from "_+_Portal/assets/images/generico/EstudioIcon";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import LaboratorioIcon from "_+_Portal/assets/images/generico/LaboratorioIcon";

export const filterContents = (removeFromTheSidebar, items) => {
  return items.filter(
    (item) => item.link && !includeCustom(removeFromTheSidebar, item.link),
  );
};

const includeCustom = (array, link) => {
  let include = false;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (element.link === link && !element.active) {
      include = true;
    }
  }
  return include;
};

export const listItems = (setItemSelected, url, autorizado) => {
  const config = getLocalStorage("config", {});
  const idTerminal = getLocalStorage("idTerminal");

  let opcAutoCheckInLabo = config?.opcAutoCheckInLabo;

  let removeFromTheSidebar = [
    {
      link: "/laboratorio",
      active: opcAutoCheckInLabo,
    },
    {
      link: "/proximosTurnos",
      active: autorizado,
    },
  ];

  let listToRender = {
    titles: ["Turnos", "Información"],
    contents: [
      [
        {
          title: "Home",
          icon: <TildeOk color={"var(--color-white)"} />,
          link: "/autocheckin",
        },
        {
          title: "Consulta Médica",
          icon: <ConsultaIcon color={"var(--color-white)"} />,
          link: idTerminal ? "/buscadorCheckin" : "/consultamedica",
        },
        {
          title: "Estudios",
          icon: <EstudioIcon color={"var(--color-white)"} />,
          link: idTerminal ? "/buscadorEstudios" : "/estudios",
        },
        {
          title: "Laboratorio",
          icon: <LaboratorioIcon color={"var(--color-white)"} />,
          link: idTerminal ? "/centrosLabo" : "/laboratorio",
        },
        {
          title: "Próximos turnos",
          icon: <MiTurnoIcon color={"var(--color-white)"} />,
          link: "/proximosTurnos",
        },
      ],
      [
        {
          title: "Salir",
          icon: <SalirIcon color={"var(--color-white)"} />,
          link: "/",
        },
      ],
    ],
  };

  listToRender.contents = listToRender.contents.map((content) => {
    return filterContents(removeFromTheSidebar, content);
  });

  listToRender.contents.map((content, index1) => {
    content.map((item, index2) => {
      const element = item;
      if (element.link === url) {
        setItemSelected({ [index1]: index2 });
      }
    });
  });

  return listToRender;
};
